import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { checkIconSvg } from '../../assets/images';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { LoginCard } from '../../stories/LoginCard';

export interface ForgotPasswordSubmissionSuccessPageProps {}

export const ForgotPasswordSubmissionSuccessPage: React.FC<
  ForgotPasswordSubmissionSuccessPageProps
> = () => {
  const __ = useTranslation().t;

  return (
    <Background>
      <Container>
        <div className="oejr-page-login oejr-page-login-secondary oejr-page-login-no-logo">
          <LoginCard showCharacters={false}>
            <div className="d-flex flex-column align-items-center text-center justify-content-center">
              <div className="oejr-login-success-icon-wrapper">
                <img src={checkIconSvg} alt="Check Icon" />
              </div>
              <h3>{__('passwordChangedSuccessfully')}</h3>
              <p>{__('passwordChangedSuccessfullyMessage')}</p>
              <Button
                id="oejr-login-submit-button"
                label={__('login')}
                variant="primary"
                href={SITE_LINKS.LoginPage}
              />
            </div>
          </LoginCard>
        </div>
      </Container>
    </Background>
  );
};
